<template>
  <div class="input-color-picker" ref="colorpicker">
    <b-input
      type="text"
      size="sm"
      v-bind:style="getInputStyle"
      @focus="openPicker"
    >
      color
    </b-input>
    <div class="color-picker-popup" v-show="showPicker">
      <chrome-picker v-model="color" @input="updateValue" />
    </div>
  </div>
</template>

<script>
import { Chrome } from "vue-color";

export default {
  name: "InputColorPicker",
  props: ["value"],
  components: {
    "chrome-picker": Chrome
  },
  data() {
    return {
      showPicker: false,
      color: this.value
    };
  },
  methods: {
    updateValue() {
      this.$emit("input", this.getRGB);
    },
    openPicker() {
      document.addEventListener("click", this.documentClick);
      this.showPicker = true;
    },
    closePicker() {
      document.removeEventListener("click", this.documentClick);
      this.showPicker = false;
    },
    documentClick(e) {
      var el = this.$refs.colorpicker,
        target = e.target;
      if (el !== target && !el.contains(target)) {
        this.closePicker();
      }
    }
  },
  computed: {
    getRGB() {
      if (this.color instanceof Object) {
        let red = this.color.rgba.r,
          green = this.color.rgba.g,
          blue = this.color.rgba.b,
          alpha = this.color.rgba.a;

        return "rgba(" + red + "," + green + "," + blue + "," + alpha + ")";
      }

      return this.color;
    },
    getInputStyle() {
      return {
        backgroundColor: this.getRGB
      };
    }
  },
  mounted() {}
};
</script>

<style scoped>
input {
  cursor: pointer;
}
.input-color-picker {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAMElEQVQ4T2N89uzZfwY8QFJSEp80A+OoAcMiDP7//483HTx//hx/Ohg1gIFx6IcBALl+VXknOCvFAAAAAElFTkSuQmCC);
  position: relative;
}

.color-picker-popup {
  position: absolute;
  left: calc(-100% - 14px);
  top: 42px;
  padding: 7px;
  background-color: #ffffff;
  border: 1px solid #d2ddec;
  border-radius: 5px;
  box-shadow: 0px 5px 7px #00000017;
  z-index: 1;
}

.vc-chrome {
  box-shadow: none;
}

.vc-chrome:after,
.vc-chrome:before {
  bottom: 100%;
  left: 75%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.vc-chrome:after {
  border-color: rgba(136, 183, 213, 0);
  border-bottom-color: #ffffff;
  border-width: 8px;
  margin-left: -8px;
}
.vc-chrome:before {
  border-color: rgba(194, 225, 245, 0);
  border-bottom-color: #d2ddec;
  border-width: 10px;
  margin-left: -10px;
}
</style>
